var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "contact"
  }, [_c('Form', {
    attrs: {
      "adaptive-on900": "",
      "data-e2e": "contact"
    }
  }, [_c('ValidationProvider', {
    attrs: {
      "rules": "required",
      "name": "ФИО"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var _vm$contact;

        var errors = _ref.errors;
        return [_c('FormElement', {
          attrs: {
            "title": "ФИО:",
            "error": errors[0]
          }
        }, [_c('InputText', {
          attrs: {
            "data-e2e": "name",
            "model-value": ((_vm$contact = _vm.contact) === null || _vm$contact === void 0 ? void 0 : _vm$contact.name) || ''
          },
          on: {
            "input": function ($event) {
              return _vm.onChange({
                name: $event
              });
            }
          }
        })], 1)];
      }
    }])
  }), _vm._v(" "), _c('ValidationProvider', {
    attrs: {
      "rules": "required|phone",
      "name": "телефон"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref2) {
        var _vm$contact2;

        var errors = _ref2.errors;
        return [_c('FormElement', {
          attrs: {
            "title": "Телефон:",
            "error": errors[0]
          }
        }, [_c('div', {
          staticClass: "contact__phone"
        }, [_c('InputText', {
          attrs: {
            "model-value": ((_vm$contact2 = _vm.contact) === null || _vm$contact2 === void 0 ? void 0 : _vm$contact2.phone) || '',
            "type": "tel",
            "data-e2e": "phone",
            "autocomplete": "tel"
          },
          on: {
            "input": function ($event) {
              return _vm.onChange({
                phone: $event
              });
            }
          }
        })], 1)])];
      }
    }])
  }), _vm._v(" "), _c('ValidationProvider', {
    attrs: {
      "name": "почту",
      "rules": "email"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref3) {
        var _vm$contact3;

        var errors = _ref3.errors;
        return [_c('FormElement', {
          attrs: {
            "title": "Email:",
            "error": errors[0]
          }
        }, [_c('InputText', {
          attrs: {
            "model-value": ((_vm$contact3 = _vm.contact) === null || _vm$contact3 === void 0 ? void 0 : _vm$contact3.email) || ''
          },
          on: {
            "input": function ($event) {
              return _vm.onChange({
                email: $event
              });
            }
          }
        })], 1)];
      }
    }])
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }